module.exports = __webpack_public_path__ + "static/img/04.f0210319.jpg";